import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-foreground-300">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-white font-heading text-lg mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors">女神漫画</Link>
            </h4>
            <p className="text-sm leading-relaxed text-foreground-400">
              聚焦韩漫、日漫、国漫热门推荐，提供排行榜精选、免费全集下拉式在线漫画阅读，追更收藏尽在女神漫画。
            </p>
          </div>

          <div>
            <h4 className="text-white font-medium text-sm mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">排行榜</Link>
              </li>
              <li>
                <Link to="/category" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">分类浏览</Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">搜索漫画</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-medium text-sm mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">韩漫精选</Link>
              </li>
              <li>
                <Link to="/category" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">日漫精选</Link>
              </li>
              <li>
                <Link to="/category" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">国漫精选</Link>
              </li>
              <li>
                <Link to="/ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">热门排行</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-medium text-sm mb-4">关于我们</h4>
            <p className="text-sm leading-relaxed text-foreground-400">
              女神漫画致力于为用户提供优质的在线漫画阅读体验。如有任何问题或建议，欢迎随时联系我们。
            </p>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:text-primary-400 hover:bg-foreground-700 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:text-primary-400 hover:bg-foreground-700 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:text-primary-400 hover:bg-foreground-700 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 女神漫画 nv-shen-manhua.com - 本站内容仅供学习交流，版权归原作者所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}